interface FinanceIncompleteBadgeProps {
  count?: number;
}

export default function FinanceIncompleteBadge({
  count,
}: FinanceIncompleteBadgeProps) {
  const suffix = typeof count === "number" ? " · " + count : "";

  return (
    <span className="inline-flex rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-800">
      Incomplete{suffix}
    </span>
  );
}
